import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Cascader } from 'antd';
import isWebView from '$src/utils/user-agent';
import eventsToIconsMap, { guardReviewed } from '$src/pages/EventSummary/EventsToIconsMap';
import Statistic from '$src/components/Statistic';

import './index.less';

function EventFilter({ total, icon, onChange, onlyEmergencies }) {
  const includeGuardReviewed = !onlyEmergencies;

  const buildEventTypeOption = (key, Icon, displayName) => ({
    value: key,
    label: (
      <span className="event-filter__cascader__item">
        <Icon /> {displayName}
      </span>
    ),
  });

  const optionsEventTypes = useMemo(
    () => [
      ...Object.entries(eventsToIconsMap)
        .filter(([key]) => eventsToIconsMap[key].isEmergency === onlyEmergencies)
        .map(([key]) => {
          const { icon: Icon, displayName } = eventsToIconsMap[key];

          return buildEventTypeOption(key, Icon, displayName);
        }),
      ...(includeGuardReviewed ? [buildEventTypeOption(guardReviewed.key, guardReviewed.icon, guardReviewed.displayName)] : []),
    ],
    [eventsToIconsMap],
  );

  return (
    <div className="event-filter">
      <Statistic value={total} Icon={icon} success={!onlyEmergencies} danger={onlyEmergencies} title="" />
      <Cascader
        data-testid="list-events-card-filter-events"
        className={`event-filter__cascader ${isWebView() ? 'avoid-autofocus' : ''}`}
        placeholder="Filter Events"
        size="middle"
        multiple
        maxTagCount="responsive"
        options={optionsEventTypes}
        onChange={onChange}
        dropdownStyle={{ height: '180px', width: '260px' }}
      />
    </div>
  );
}

EventFilter.propTypes = {
  total: PropTypes.number,
  icon: PropTypes.elementType,
  onChange: PropTypes.func,
  onlyEmergencies: PropTypes.bool
}

export default EventFilter;
